import {Order} from '../_api/api.types'

export enum EJobStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export enum EJobProgress {
  OPEN = 'OPEN',
  IN_PROGRESS = 'IN_PROGRESS',
  CLOSED = 'CLOSED',
  REJECTED = 'REJECTED',
  DRAFT = 'DRAFT',
  COMPLETED = 'COMPLETED',
  SUBMITTED = 'SUBMITTED',
  SCHEDULED = 'SCHEDULED',
}

export enum EJobPriority {
  LOW = 'LOW',
  NORMAL = 'NORMAL',
  HIGH = 'HIGH',
  CRITICAL = 'CRITICAL',
}

export enum EFormJobType {
  TEXT = 'TEXT',
  MULTIPLE_CHOICE = 'MULTIPLE_CHOICE',
  DROPDOWN = 'DROPDOWN',
  IMAGE = 'IMAGE',
  MULTIPLE_IMAGES = 'MULTIPLE_IMAGES',
  DATE = 'DATE',
  TIME = 'TIME',
}

export enum EFormJobTimeRule {
  FIXED = 'FIXED',
  FLEXIBLE = 'FLEXIBLE',
  NO_TIME = 'NO_TIME',
}

export interface IJob {
  id: string
  job_id: string
  wo_id?: string
  name: string
  time_rule?: keyof typeof EFormJobTimeRule
  start_date: string
  end_date: string
  start_time: string
  end_time: string
  total_task: string
  is_overdue?: boolean
  status: boolean
  progress: keyof typeof EJobProgress
  priority: keyof typeof EJobPriority
  is_recurring: boolean
  recurring_rule?: {
    recurring_unit?: string
    recurring_interval?: number
    recurring_days?: string
    recurring_end_date?: string
    recurring_end_count?: number
  }
  recurring_rule_id?: string
  company?: {
    id: string
    code: string
    name: string
  }
  department?: {
    id: string
    code: string
    name: string
  }
}

export interface IJobDetail extends IJob {
  wo_number: string
  address: string
  description: string
  location: string
  location_name: string
  job_type: string
  pic_agent: {id?: string; name?: string}[]
  has_approval: boolean
  approved_by: {
    id?: string
    name?: string
    type?: string
  }[]
  approval: {
    approval_date: string
    approved_by: string
    reason: string
    status: keyof typeof EJobProgress
  }[]
  has_attendance: boolean
  attendance?: {
    is_selfie: boolean
    radius: number
  }
  forms: ITaskRequest[]
  template?: {
    name?: string
    id?: string
  }
  template_id?: string
  clock_in?: string
  clock_in_selfie?: string
  clock_out?: string
  clock_out_selfie?: string
  is_overdue?: boolean
  history?: {
    approval?: boolean
    data?: {
      agent_name?: string
      progress: keyof typeof EJobProgress
      is_overdue?: boolean
      start_date?: string
      complete_date?: string
      approved_date?: string
      id?: string
    }[]
  }
  work_order?: {
    id: string
    wo_number: string
    requestor_department: {
      id: string
      name: string
    }
    attachment?: {
      original_file_name: string
      size: number
      path_url: string
    }
    histories: [
      {
        status: string
        created_at: string
        reviewed_by: {
          id: string
          name: string
        }
      }
    ]
  }
}

export interface IJobRequest {
  company_id?: string
  department_id?: string
  name?: string
  priority?: keyof typeof EJobPriority
  wo_number?: string
  wo_id?: string
  description?: string
  address?: string
  location?: string
  location_name?: string
  job_type?: string

  time_rule?: keyof typeof EFormJobTimeRule
  start_date?: string | null
  end_date?: string | null
  start_time?: string | null
  end_time?: string | null
  is_recurring?: boolean
  recurring_interval?: number | null
  recurring_unit?: string | null
  recurring_days?: string[] | null
  recurring_end_date?: string | null
  recurring_end_count?: number | null

  pic_agent_id?: string[]
  support_agents?: string[] | null
  has_attendance?: boolean
  attendance?: {
    radius?: number | null
    is_selfie?: boolean
  } | null

  approval_by?:
    | {
        id?: string
        type?: string
      }[]
    | null
  forms?: ITaskRequest[]
  status?: 'OPEN' | 'DRAFT'
  template_id?: string
}

export interface IJobQuery {
  search?: string
  page?: number
  size?: number
  sort?: string
  order?: Order
  statuses?: string[]
  priorities?: string[]
  progresses?: string[]
  start_date?: string
  end_date?: string
  company_ids?: string[]
  department_ids?: string[]
  agent_ids?: string[]
  template_ids?: string[]
  cursor?: string
  status?: string
}

interface IJobBulkValue {
  id?: string
  value: any
  is_valid: boolean
}
export interface IJobBulkRequest {
  name: IJobBulkValue
  start_time: IJobBulkValue
  end_time: IJobBulkValue
  start_date: IJobBulkValue
  end_date: IJobBulkValue
  priority: IJobBulkValue
  wo_number: IJobBulkValue
  location: IJobBulkValue
  location_name: IJobBulkValue
  department: IJobBulkValue
  company: IJobBulkValue
}

export interface ITaskRequest {
  name?: string
  type?: keyof typeof EFormJobType
  description?: string
  is_required?: boolean
  data?: {
    id?: string
    name?: string
  }[]
  value?: string
  multiple_images?: {
    image: string
    image_description: string
  }[]
}

export interface IJobRecurringChild {
  id?: string
  job_id?: string
  start_date?: string
  end_date?: string
  progress?: keyof typeof EJobProgress
  recurring_rule_id?: string
  recurring_rule?: {
    recurring_unit?: string
    recurring_interval?: number
    recurring_days?: string
    recurring_end_date?: string
    recurring_end_count?: number
  }
}

export interface IJobRecurringChildQuery {
  search?: string
  page?: number
  size?: number
  sort?: string
  order?: Order
}
